import CreateModule from "./CreateModule";

export default CreateModule